module.exports = __webpack_public_path__ + "img/dxctj-1000.6f9de3cd.jpg";